import { render } from "./Advantages.vue?vue&type=template&id=0fdbe74a&scoped=true"
import script from "./Advantages.vue?vue&type=script&lang=js"
export * from "./Advantages.vue?vue&type=script&lang=js"

import "./Advantages.vue?vue&type=style&index=0&id=0fdbe74a&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fdbe74a"],['__file',"src/components/black-friday/Advantages.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0fdbe74a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fdbe74a', __exports__)) {
    console.log('reload')
    api.reload('0fdbe74a', __exports__)
  }
  
  module.hot.accept("./Advantages.vue?vue&type=template&id=0fdbe74a&scoped=true", () => {
    console.log('re-render')
    api.rerender('0fdbe74a', render)
  })

}


export default __exports__